import { render, staticRenderFns } from "./UnsolicitedItems.vue?vue&type=template&id=14aa3afa&scoped=true&"
import script from "./UnsolicitedItems.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedItems.vue?vue&type=script&lang=js&"
import style0 from "./UnsolicitedItems.vue?vue&type=style&index=0&id=14aa3afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa3afa",
  null
  
)

export default component.exports